// extracted by mini-css-extract-plugin
module.exports = {"sideDrawer":"SideDrawer_sideDrawer__3Rd91","open":"SideDrawer_open__2DetH","myresumes":"SideDrawer_myresumes__2DqG6"};